import { render, staticRenderFns } from "./companyDataForm.vue?vue&type=template&id=2ae89184&"
import script from "./companyDataForm.vue?vue&type=script&lang=js&"
export * from "./companyDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports